import { configureStore } from "@reduxjs/toolkit";
import { configureAuthHandlers } from "../utils/api";

import authSlice from "./slice/authSlice";
import locationSlice from "./slice/location/locationSlice";
import serviceSlice from "./slice/service/serviceSlice";
import providerSlice from "./slice/provider/providerSlice";
import handymanSlice from "./slice/handyman/handymanSlice";
import bookingSlice from "./slice/booking/bookingSlice";
import paymentSlice from "./slice/payment/paymentSlice";
import adminProviderSlice from "./slice/admin/adminProviderSlice";
import reviewSlice from "./slice/review/reviewSlice";

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    location: locationSlice.reducer,
    service: serviceSlice.reducer,
    provider: providerSlice.reducer,
    handyman: handymanSlice.reducer,
    booking: bookingSlice.reducer,
    payment: paymentSlice.reducer,
    adminProvider: adminProviderSlice.reducer,
    review: reviewSlice.reducer,
  },
});

configureAuthHandlers({
  onTokenRefreshed: (token) => store.dispatch(authSlice.actions.loginSuccess(token)),
  onSessionExpired: () => store.dispatch(authSlice.actions.logout()),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = (
  dispatch: AppDispatch,
  getState: () => RootState
) => ReturnType | Promise<ReturnType>;

export default store;
